module.exports = __webpack_public_path__ + "static/media/ribbon.06efbf37.svg";